import React, { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";
import { omit } from "lodash";

type PropsDef = {
  id?: string;
  path: string;
  query: {};
  label: string;
  addComma?: boolean;
};

const LinkToReport = (props: PropsDef) => {
  const { path, query, label, addComma = false } = props;

  const { search } = useLocation();
  const prevQuery = useMemo(() => {
    const params = new URLSearchParams(search);
    const result = {};
    for (const [key, value] of params.entries()) {
      result[key] = value;
    }
    return omit(result, ["page", "per_page"]);
  }, [search]);

  // @ts-ignore
  const newQuery = new URLSearchParams({
    ...prevQuery,
    ...query,
    ...{ page: 1 },
  });

  return (
    <Link
      to={{
        pathname: path,
        search: newQuery.toString(),
      }}
      target="_blank"
      rel="noreferrer"
    >
      <a target="_blank" className="text-primary-text font-bold cursor-pointer">
        {label}
        {addComma ? "," : ""}
      </a>
    </Link>
  );
};

export default LinkToReport;
